<template>
  <div 
    v-on-clickaway="hidesidemenu"
    class="sidemenuwrapper">
    
    <div class="userprofile">

        <template v-if="user && user.image">
                <div 
                class="userimage" 
                :style="`background-image:url(https://picsum.photos/id/684/600/400);`">
            </div>
        </template>

        <template v-else>
            <div class="userimage">
                <b-icon icon="person-circle"></b-icon>
            </div>
        </template>
        
        <div class="userinfo">
            <div class="name">{{user ? user.name : ''}}</div>
            <template v-if="islogin">
                <a href="" @click.prevent="logout">Logout</a>
            </template>
            <template v-else>
                <a href="" @click.prevent="$router.push({name : 'login'}), $emit('update:showmenu', false)">Login</a>
            </template>
        </div>
    </div>
    <b-list-group >

        <template v-for="menu in menus">

            <b-list-group-item 
                :key="menu.route"
                href="" 
                :class="[{'active' : $route.name == menu.route}]"
                @click.prevent="goto(menu.route)">
                <b-icon :icon="menu.icon"></b-icon> 

                
                <template v-if="hassubscription && menu.route == 'product'">
                    Edit Order
                </template>

                <template v-else>
                    {{menu.name}}
                </template>

            </b-list-group-item>
        </template>

        
    </b-list-group>
  </div>
</template>

<script>
//Helpers
import Helper from '@/helpers/helper'

// plugins
import axios from 'axios'

// Directives
import { directive as onClickaway } from 'vue-clickaway';

export default {
    props : {
        /**
         * Side menu state
         */
        showmenu : {
            type   : Boolean,
            default: () => {
                return false;
            }
        }
    },  
    directives: {
        onClickaway: onClickaway,
    },
    computed : {
         /**
         * Check if user has subscriptions
         */
        hassubscription () {
            const [sub] = this.$store.state.subscriptions;
            return sub ? true : false;
        },
        /**
         * Navigation menus
         */
        menus() {
            return this.$store.state.menus
        },
        /**
         * Logged In status
         */
        islogin : {
            get() {
                return this.$store.state.islogin
            },
            set(status) {
                this.$store.commit('updateloginstatus', status)
            }
        },
        /**
         * Logged In user
         */
        user() {
            return this.$store.state.user
        }
    },
    methods : {
        /**
         * Navigation to page,
         * check condition like if has subscription
         */
        goto(route) {
            if(this.hassubscription && route == 'product') {
                this.$router.push({name : 'editsubscription'})
            } else {
                this.$router.push({name : route})
            }

            this.$emit('update:showmenu', false)
        },
        /**
         * Logout account
         * delete session cookie
         */
        async logout() {
            this.$emit('update:showmenu', false)
            await Helper.deleteCookie('holeswebtoken');
            await axios.post('/logout');
            this.$router.push({name : 'login'});
        },
        /**
         * Hide side menu when clicked outside of the side menu
         * but add header profile button to the exemption
         */
        hidesidemenu(e) {

            const paths = Array.from(e.path);
            const profile  = paths.map(p => p.dataset).find(d => d ? d.clickaway == 'menu' : null);

            console.log('e', profile);

            if(!profile) {
                this.$emit('update:showmenu', false);
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/_settings.scss';

.sidemenuwrapper {
    box-shadow: -5px 0 10px -5px $dark-gray;
    height    : 100vh;
    position  : relative;
    z-index   : 500;

    .list-group {
        width     : 300px;
        box-shadow: none;

        .list-group-item {
            cursor: pointer;

            svg {
                margin-right : 10px;
            }

            &:hover {
                background-color: $primary-color;
                color           : white;
            }

            &.active {
                background-color: $primary-color;
                color           : white;
            }
        }
    }

    .userprofile {
        display: flex;
        padding: 15px;

        .userimage {
            width          : 30px;
            height         : 30px;
            flex           : 0 0 30px;
            border-radius  : 100%;
            background-size: cover;
            margin-right   : 10px;
            font-size      : 25px;
            display        : flex;
            align-items    : center;
            justify-content: center;
            color          : $dark-gray;
        }

        a {
            font-size: 15px;
            color    : $primary-color;
        }
    }
}
</style>